var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownNarrow = function SvgArrowDownNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.06 15.94a1.5 1.5 0 0 1 0 2.121l-4 4a1.5 1.5 0 0 1-.23.19l-.031.018a1.5 1.5 0 0 1-.228.117l-.05.019q-.041.016-.086.03l-.06.017-.084.02c-.192.037-.39.037-.583 0l-.072-.018-.07-.019-.088-.03-.048-.019a1.5 1.5 0 0 1-.228-.117l-.03-.018a1.5 1.5 0 0 1-.233-.19l-4-4a1.5 1.5 0 0 1 2.122-2.121l1.439 1.44V3a1.5 1.5 0 0 1 3 0v14.38l1.44-1.44a1.5 1.5 0 0 1 2.12 0"
  })));
};
export default SvgArrowDownNarrow;